export function updateSwapEndResults (state, payload) {
  const { cameraId, designId, hotspotUid, isSuccessful, productId } = payload;

  const swapEndResults = { ...state.swapEndResults };
  swapEndResults[`${designId}:${hotspotUid}:${productId}:${cameraId}`] = isSuccessful;

  return {
    ...state,
    swapEndResults
  };
}

export function updateSwapStatuses (state, payload) {
  const { cameraId, designId, hotspotUid, productId } = payload;

  const designSwappingStatus = state.designSwappingStatuses[designId];
  let newDesignSwappingStatus = designSwappingStatus ? { ...designSwappingStatus } : {};
  let swapEndResults;

  // if no hotspot or product info included
  // we are clearing out the swap status
  // if included, we are initiating a swap
  if (hotspotUid && productId) {
    newDesignSwappingStatus[hotspotUid] = productId;
    const priorSwapResult = state.swapEndResults[`${designId}:${hotspotUid}:${productId}:${cameraId}`];

    // we will delete the prior swap results because we are initiating a new swap
    if (priorSwapResult) {
      swapEndResults = { ...state.swapEndResults };
      delete swapEndResults[`${designId}:${hotspotUid}:${productId}:${cameraId}`];
    }
  } else {
    newDesignSwappingStatus = {};
  }

  const designSwappingStatuses = {
    ...state.designSwappingStatuses,
    [designId]: newDesignSwappingStatus
  };

  const newState = {
    ...state,
    designSwappingStatuses
  };

  if (swapEndResults) {
    newState.swapEndResults = swapEndResults;
  }

  return newState;
}

export function updateDesignToCamera (state, payload) {
  const { designId, camera } = payload;
  const designToCameraDict = { ...state.designToCameraDict };
  designToCameraDict[designId] = camera;

  return { ...state, designToCameraDict };
}

export function updateDesignToPlayground (state, payload) {
  const { playgroundId, designId } = payload;
  const designToPlaygroundDict = { ...state.designToPlaygroundDict };
  designToPlaygroundDict[designId] = playgroundId;

  return { ...state, designToPlaygroundDict };
}

export function updateRenderApiPollTimeoutId (state, payload) {
  const { designId, timeoutId } = payload;
  const renderApiPolls = { ...state.renderApiPolls };
  renderApiPolls[designId] = timeoutId;

  return { ...state, renderApiPolls };
}

export function clearRenderApiPollTimeout (state, payload) {
  const { designId } = payload;
  const renderApiPolls = { ...state.renderApiPolls };
  const timeoutId = renderApiPolls[designId];

  clearTimeout(timeoutId);
  renderApiPolls[designId] = null;

  return { ...state, renderApiPolls };
}
